import React, { useState, useEffect, useRef } from 'react';
import { FaSearch } from 'react-icons/fa';
import { FiChevronsLeft, FiChevronLeft, FiChevronRight, FiChevronsRight } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import { isLoggedIn } from '../../../utils/auth';

import CyberMemorialService from '../../../services/FamilyPlaza/CyberMemorialService';
import FamilyPlazaSubHeading from '../../../components/family-plaza/FamilyPlazaSubHeading';
import FamilyPlazaTopSection from '../../../components/family-plaza/FamilyPlazaTopSection';

const CyberMemorialSearchMobile = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchType, setSearchType] = useState('고인명');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(9);
  const [showSearchResults, setShowSearchResults] = useState(false);
  const [isComposing, setIsComposing] = useState(false);

  // Calculate pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = searchResults.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(searchResults.length / itemsPerPage);

  // Generate page numbers array with sliding window
  const getPageNumbers = () => {
    const pageNumbers = [];
    const maxVisiblePages = 10;

    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
      let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

      if (endPage - startPage + 1 < maxVisiblePages) {
        startPage = Math.max(1, endPage - maxVisiblePages + 1);
      }

      for (let i = startPage; i <= endPage; i++) {
        pageNumbers.push(i);
      }
    }

    return pageNumbers;
  };



  const handleSearchClick = async (e, result) => {
    e.preventDefault();
    e.stopPropagation();



    // Store the selected person's data in localStorage
    const selectedPerson = {
      goinName: result.goinName,
      enshrineDay: result.enshrineDay,
      customerName: result.customerName,
      enshrineDate: result.enshrineDate,
      goinId: result.goinId,
      customerBirthday: result.customerBirthday,
      deathDate: result.deathDate,

    };
    localStorage.setItem('selectedPersonData', JSON.stringify(selectedPerson));

    // Navigate directly to donate page
    navigate('/donate');
  };

  // These functions are now handled in the profile section
  // Authentication and photo modals will be triggered from profile photo icon

  // API Functions
  const searchGoins = async (name) => {
    try {
      setIsLoading(true);

      // Create search parameters based on search type
      let searchParams;
      if (searchType === '고인명') {
        searchParams = { deceasedName: name };
      } else if (searchType === '계약자명') {
        searchParams = { contractorName: name };
      } else {
        // Default to deceasedName if searchType is not recognized
        searchParams = { deceasedName: name };
      }

      const response = await CyberMemorialService.searchGoins(searchParams);

      if (response && response && Array.isArray(response)) {
        setSearchResults(response);
      } else {
        setSearchResults([]);
      }
    } catch (error) {
      setSearchResults([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearch = async () => {
    const logged = localStorage.getItem('isLoggedIn') === 'true' || !!localStorage.getItem('authToken') || localStorage.getItem('modalAuthenticated') === 'true';
    if (!logged) {
      alert('회원전용 서비스입니다. 로그인을해주세요.');
      return;
    }

    if (searchQuery.trim()) {
      await searchGoins(searchQuery.trim());
    } else {
      // await loadAllGoins();
    }
    setShowSearchResults(true);
  };

  const handleSearchInputChange = (e) => {
    const value = e.target.value;
    if (isComposing || e.nativeEvent.isComposing) {
      setSearchQuery(value);
      return;
    }
    // Allow full Hangul ranges (Jamo + Compatibility Jamo + Syllables), English letters, spaces, and dots
    const textOnlyRegex = /^[\u1100-\u11FF\u3130-\u318F\uAC00-\uD7A3a-zA-Z\s.]*$/;
    if (textOnlyRegex.test(value) || value === '') {
      setSearchQuery(value);
    }
  };

  const handleSearchTypeChange = (type) => {
    setSearchType(type);
  };

  // Pagination functions
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleFirstPage = () => {
    setCurrentPage(1);
  };

  const handleLastPage = () => {
    setCurrentPage(totalPages);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  // Calculate visible page numbers
  const getVisiblePageNumbers = () => {
    const pages = [];
    const halfVisible = Math.floor(5 / 2); // Assuming visiblePages is 5

    let start = Math.max(1, currentPage - halfVisible);
    let end = Math.min(totalPages, start + 5 - 1);

    if (end - start + 1 < 5) {
      start = Math.max(1, end - 5 + 1);
    }

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    return pages;
  };

  // Load all goins API
  const loadAllGoins = async () => {
    try {
      setIsLoading(true);
      const response = await CyberMemorialService.loadAllGoins();

      if (response && response && Array.isArray(response) && response.length > 0) {
        setSearchResults(response);
      } else {
        setSearchResults([]);
      }
    } catch (error) {
      setSearchResults([]);
    } finally {
      setIsLoading(false);
    }
  };

  // Check if user just logged in and should show results
  useEffect(() => {
    if (isLoggedIn() && localStorage.getItem('showResultsAfterLogin') === 'true') {
      localStorage.removeItem('showResultsAfterLogin');
      loadAllGoins();
      setShowSearchResults(true);
    }
  }, []);

  // Remove automatic data loading on component mount
  // Data will only be loaded when search icon is clicked



  const handleMemorialPost = () => {
    // Navigate without any authentication checks
    navigate('/memorial-post-board-list');
  };

  const handleLetterToHeaven = () => {
    // Navigate without any authentication checks
    navigate('/letter-to-heaven-board-list');
  };

  const handleManagementInquiry = () => {
    // Navigate without any authentication checks
    navigate('/management-search');
  };

  const handleAncestralTablet = () => {
    // Navigate without any authentication checks
    navigate('/ancestral-tablet');
  };

  return (
    <div className="announcement-list-page cyber-info-page-pc">

      <FamilyPlazaTopSection />

      <main className="main-content">

        <FamilyPlazaSubHeading heading="사이버추모관" />

        
        {/* Content Section */}
        <div className="cyber-memorial-search-mobile-content-section">
          <div className="cyber-memorial-search-mobile-content-container">
            <div className="cyber-memorial-search-mobile-intro-section">
              <p className="cyber-memorial-search-mobile-intro-text">
                사이버추모관은 추모원에 직접 방문하지 못해도 언제, 어디서나 가족이나 친지 등 고인에 대한 영정과 함께 추모의 글과 음악으로 고인을 추모할 수 있는 온라인 서비스입니다.
              </p>
              <p className="cyber-memorial-search-mobile-intro-bold">
                추모원에 모셔진 고인을 아래의 검색창에 검색해주세요.
              </p>
            </div>

          {/* Search Filter Buttons */}
        <div className="cyber-memorial-search-mobile-filter-buttons">
          <button
            type="button"
            className={`cyber-memorial-search-mobile-filter-btn ${searchType === '고인명' ? 'active' : ''}`}
            aria-pressed={searchType === '고인명'}
            style={{ backgroundColor: searchType === '고인명' ? '#1abc9c' : '#444' }}
            onClick={() => setSearchType('고인명')}
          >
            고인명
          </button>
          <button
            type="button"
            className={`cyber-memorial-search-mobile-filter-btn ${searchType === '계약자명' ? 'active' : ''}`}
            aria-pressed={searchType === '계약자명'}
            style={{ backgroundColor: searchType === '계약자명' ? '#1abc9c' : '#444' }}
            onClick={() => setSearchType('계약자명')}
          >
            계약자명
          </button>
        </div>

            <div className="cyber-memorial-search-mobile-search-section">
              <div className="cyber-memorial-search-mobile-search-bar">
                <input
                  type="text"
                  placeholder="이름을 입력해 주세요"
                  className="cyber-memorial-search-mobile-search-input"
                  value={searchQuery}
                  onChange={handleSearchInputChange}
                  onCompositionStart={() => setIsComposing(true)}
                  onCompositionEnd={(e) => { setIsComposing(false); setSearchQuery(e.target.value); }}
                  onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
                  lang="ko"
                  inputMode="text"
                  autoComplete="off"
                  spellCheck="false"
                  style={{ fontFamily: 'inherit' }}
                />
                <button
                  className="cyber-memorial-search-mobile-search-btn"
                  onClick={handleSearch}
                  disabled={isLoading}
                >
                  {isLoading ? '검색중...' : <FaSearch />}
                </button>
              </div>
            </div>

            {/* Information Section */}
            <div className="cyber-memorial-search-mobile-info-section">
              <div className="cyber-memorial-search-mobile-info-item">
                <div className="cyber-memorial-search-mobile-info-icon">!</div>
                <span>로그인 후 이용 가능합니다.</span>
              </div>
              <div className="cyber-memorial-search-mobile-info-item">
                <span>조회가 안되는 회원분께서는 관리사무실</span>
              </div>
              <div className="cyber-memorial-search-mobile-info-item">
                <span className="cyber-memorial-search-mobile-phone">1599-9442</span>
                <span>로 연락바랍니다.</span>
              </div>
            </div>

            {/* Results Table */}
            {showSearchResults && (
              <div className="cyber-memorial-search-mobile-results-section">
                {currentItems.length > 0 && (
                  <table className="cyber-memorial-search-mobile-table">
                    <thead>
                      <tr>
                        <th>고인명</th>
                        <th>안치일</th>
                        <th>계약자</th>
                        <th>조회하기</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentItems.map((result, index) => (
                        <tr key={index}>
                          <td>{result.goinName || '故 홍길동'}</td>
                          <td>{result.enshrineDay || '2011-01-01'}</td>
                          <td>{result.customerName || '김추모'}</td>
                          <td>
                            <div
                              className="cyber-memorial-search-mobile-inquire-btn"
                              onClick={(e) => handleSearchClick(e, result)}
                              style={{
                                pointerEvents: 'auto',
                                cursor: 'pointer',
                                background: '#ccc',
                                border: 'none',
                                borderRadius: '50%',
                                width: '30px',
                                height: '30px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: 'white',
                                margin: '0 auto'
                              }}
                            >
                              <FaSearch />
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
                {searchQuery && searchResults.length === 0 && !isLoading && (
                  <div className="cyber-memorial-search-mobile-no-results">
                    검색 결과가 없습니다.
                  </div>
                )}

                {/* Pagination */}
                {totalPages > 1 && searchResults.length > 0 && (
                  <div className="cyber-memorial-search-mobile-pagination">
                    <button
                      className="cyber-memorial-search-mobile-pagination-btn"
                      onClick={handleFirstPage}
                      disabled={currentPage === 1}
                    >
                      <FiChevronsLeft />
                    </button>
                    <button
                      className="cyber-memorial-search-mobile-pagination-btn"
                      onClick={handlePrevPage}
                      disabled={currentPage === 1}
                    >
                      <FiChevronLeft />
                    </button>
                    {getPageNumbers().map((page) => (
                      <button
                        key={page}
                        className={`cyber-memorial-search-mobile-pagination-btn ${currentPage === page ? 'active' : ''}`}
                        onClick={() => handlePageChange(page)}
                      >
                        {page}
                      </button>
                    ))}
                    <button
                      className="cyber-memorial-search-mobile-pagination-btn"
                      onClick={handleNextPage}
                      disabled={currentPage === totalPages}
                    >
                      <FiChevronRight />
                    </button>
                    <button
                      className="cyber-memorial-search-mobile-pagination-btn"
                      onClick={handleLastPage}
                      disabled={currentPage === totalPages}
                    >
                      <FiChevronsRight />
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </main>


    </div>
  );
};

export default CyberMemorialSearchMobile; 
